import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const HolidayCalendar = () => import('./index.vue')

export const holidayCalendarRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CALENDAR_HOLIDAY_VIEW
  ])
) {
  holidayCalendarRoutes.push({
    path: '/calendarios/feriados',
    name: 'Cadastro / Consulta|Calendário de Feriados',
    component: HolidayCalendar,
    meta: {
      icon: 'fa-calendar',
      requiresAuth: true,
    },
  });
}
